const env = import.meta.env

const { MODE, VITE_API_BASE_URL, VITE_LANGUAGE_NODE_ID, VITE_MOBILE_REDIRECT_URL } = env

const iconfontVersion = ['4855758_k39rjyjt7lm']
const iconfontUrl = `//at.alicdn.com/t/c/font_5068761_nnx80ohe8u.css`

const baseUrl = VITE_API_BASE_URL
const languageNodeId = VITE_LANGUAGE_NODE_ID
const mobileRedirectUrl = VITE_MOBILE_REDIRECT_URL
const domain = ''
const isDev = MODE === 'development'

export { baseUrl, domain, iconfontUrl, iconfontVersion, languageNodeId, mobileRedirectUrl, isDev }
